import React from 'react';
import clsx from 'clsx';

import Typography from '@material-ui/core/Typography';

import Title from '../../components/Title/Title';

import useStyles from './Style';

const DisposicoesFinais = ({ edicao }) => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-10" className={classes.title}>
                10. DISPOSIÇÕES FINAIS
            </Title>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>10.1</span> 
                A inscrição na {edicao}ª Olimpíada de Professores da OBMEP Mirim implicará na tácita aceitação das normas e condições estabelecidas neste Regulamento, incluindo seus anexos e eventuais retificações, 
                das quais os professores não poderão alegar desconhecimento.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>10.2</span> 
                A divulgação de dados específicos e não estatísticos da Olimpíada de Professores da OBMEP Mirim fica condicionada à autorização do Ministério da Ciência, Tecnologia e Inovação (MCTI) e do 
                Ministério da Educação (MEC), bem como ao cumprimento da legislação de proteção de dados à época vigente, de modo a garantir a privacidade dos participantes.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>10.3</span>
                Ao se inscrever na Olimpíada de Professores da OBMEP Mirim, o professor declara-se ciente, para fins de execução do presente regulamento e participação no certame cultural, que o 
                <span className={classes.bolder}>IMPA</span> tratará seus dados, obrigando-se a tratar os dados pessoais coletados no momento do recebimento destes de acordo com a legislação vigente aplicável, 
                incluindo, mas não se limitando à Lei nº 12.965, de 23 de abril de 2014 e Decreto nº 8.771, de 11 de maio de 2016 (“Marco Civil da Internet”) e Lei nº 13.709, de 14 de agosto de 2018 
                (“Lei Geral de Proteção de Dados” ou “LGPD”), no que couber e for aplicável. Mais detalhes podem ser consultados no Aviso Externo de Privacidade disponível 
                em <span className={classes.underline}>https://impa.br/sobre/acesso-a-informacao/aviso-de-privacidade/</span>.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>10.4</span> 
                Finalidades dos tratamentos: O tratamento dos dados pessoais ora coletados possui como finalidades: (i) identificar o participante; (ii) viabilizar a divulgação e publicação do andamento da olimpíada 
                (iii) realização/entrega de premiações e convites; (iv) publicação do resultado final da olimpíada; (v) viabilizar o envio de comunicados diversos ao candidato; (vi) permitir acesso aos sistemas 
                e às ferramentas disponibilizados pelo <span className={classes.bolder}>IMPA</span> no âmbito da olimpíada; (vii) permitir o exercício regular de direitos assegurados ao <span className={classes.bolder}>IMPA</span>, 
                e (viii) realização de estudos estatísticos.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>10.5</span>
                O dado pessoal sensível correspondente à raça somente será usado para a elaboração de estudos estatísticos, pelo próprio <span className={classes.bolder}>IMPA</span>, sendo compartilhados 
                apenas de forma totalmente anonimizada.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>10.6</span>
                Os dados pessoais tratados pelo <span className={classes.bolder}>IMPA</span> são mantidos apenas por período indispensável para alcance das finalidades apresentadas nesse aviso de 
                privacidade e por eventual período adicional quando necessário para cumprimento de obrigações legais.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>10.7</span>
                Mais detalhes sobre as medidas de segurança adotadas pela Instituição podem ser encontrados na Política de Segurança da Informação disponível no link <span className={clsx(classes.bolder, classes.underline)}>https://www.obmep.org.br/avisoDePrivacidade.htm</span>.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>10.8</span>
                Os dados pessoais coletados poderão ser compartilhados com terceiros que sejam contratados pelo <span className={classes.bolder}>IMPA</span> para apoio na realização da olimpíada e, ainda, 
                com parceiros para realização de estudos, comprometendo-se a Instituição a realizar o compartilhamento no exato limite e tempo necessários à realização das atividades.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>10.9</span>
                Para o saneamento de dúvidas ou exercício dos direitos assegurados pela LGPD, o candidato poderá entrar em contato através do e-mail <span className={classes.underline}>privacidade@impa.br</span>.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>10.10</span>
                Os casos omissos e as eventuais dúvidas referentes a este Regulamento serão decididos e esclarecidos pelo <span className={classes.bolder}>IMPA</span>.
            </Typography>
        </>
    )
}

export default DisposicoesFinais;